"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addChartToDashboard = void 0;
const ChartType_1 = __importDefault(require("@opsbase/lib-chart/ChartType"));
const consts_1 = require("@opsbase/web-app/consts");
const uuid = __importStar(require("uuid"));
const calcTitleForChart_1 = __importDefault(require("../helpers/calcTitleForChart"));
function addChartToDashboard(existingWidgets, query, chart) {
    if (existingWidgets.length >= consts_1.maxWidgetsPerDashboard)
        return existingWidgets;
    let size;
    switch (chart.chartType) {
        case ChartType_1.default.TABLE3D:
        case ChartType_1.default.LINE3DGROUP:
            size = { w: 6, h: 7 };
            break;
        case ChartType_1.default.BAR2D:
        case ChartType_1.default.PIE2D:
            size = { w: 3, h: 3 };
            break;
        default:
            size = { w: 6, h: 4 };
            break;
    }
    const coords = Object.assign(Object.assign({}, size), { x: 0, y: existingWidgets.reduce((p, c) => Math.max(p, c.coords.y), 0) });
    const title = (0, calcTitleForChart_1.default)(query, chart);
    const newWidget = {
        key: uuid.v4(),
        title,
        coords,
        chart,
        query,
    };
    return [...existingWidgets, newWidget];
}
exports.addChartToDashboard = addChartToDashboard;
exports.default = addChartToDashboard;
